import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d2f1727"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "title-wrapper" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "title" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "모바일 ID"),
    /*#__PURE__*/_createTextVNode("로"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 구성원을 확인합니다. ")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "detail" }, "탑승 시 모바일 ID를 태블릿에 스캔해주세요")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createVNode($setup["NavigationBar"], {
        title: "모바일 ID",
        isUnderline: $setup.isScrolling
      }, null, 8 /* PROPS */, ["isUnderline"]),
      _createElementVNode("div", {
        class: "content-area",
        onScroll: $setup.onScroll
      }, [
        _hoisted_1,
        _createVNode($setup["QRCode"], { class: "qrcode-wrapper" })
      ], 32 /* NEED_HYDRATION */),
      _createCommentVNode(" <section class=\"service-evaluation\">\n      <p>탑승하신 노선 어떠셨나요?</p>\n      <BaseButton\n        class=\"base-button\"\n        title=\"서비스 평가하기\"\n        :disabled=\"!isEvaluable\"\n        @onClick=\"toggleShowServiceEvaluation(true)\"\n      />\n    </section>\n\n    <PageModal\n      :shouldShow=\"shouldShowServiceEvaluation\"\n      :onBackHandler=\"() => toggleShowServiceEvaluation(false)\"\n    >\n      <ServiceEvaluation\n        @onClickClose=\"toggleShowServiceEvaluation(false)\"\n      />\n    </PageModal> ")
    ]),
    _: 1 /* STABLE */
  }))
}